export default function PHP_AbstractClasses() {
  return (
    <div>
      <h1>PHP_AbstractClasses</h1>
    </div>
  );
}
